import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  box: {
    maxWidth: '430px'
  }
});

export default { useStyles };
